import { styled } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import OriginalAntSwitch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import { colors } from '../../styles/colors';
import { SwitchButton, SwitchText } from './styles';

const AntSwitchWrapper = styled(OriginalAntSwitch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    top: '-1px',
    padding: 2,
    color: colors.White,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      marginLeft: '4px',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },

  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    marginTop: '1px',
    boxShadow: 'none',
  },

  '& .MuiSwitch-track': {
    border: `1px solid ${colors.White}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: colors.Grey200,
    borderColor: colors.Grey200,
  },
}));

type AntSwitchProps = {
  checked: boolean;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export const AntSwitch = ({ checked, label, onChange }: AntSwitchProps): JSX.Element => (
  <SwitchButton>
    <FormGroup>
      <Typography component="div">
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid item>
            <AntSwitchWrapper checked={checked} onChange={onChange} />
          </Grid>
          <SwitchText switchOn={checked}>
            {label}
          </SwitchText>
        </Grid>
      </Typography>
    </FormGroup>
  </SwitchButton>
);
